<div class="flex-container">
  <div class="row">
    <div class="flex-item">
      <card-component>
        <card-content>
          <img id="profile-img" alt="logo" class="profile-img-card" src="assets/img/logo.png" />
          <div class="reset-password">
            @if (showChallenge) {
              <two-factor-challenge [loginSuccessful]="redirect"></two-factor-challenge>
            } @else {
              <login-form [loginSuccessful]="redirect" [showChallenge]="displayChallengeScreen"></login-form>
              <flat-button [styles]="{ width: '100%', 'margin-top': '20px' }" color="primary" (click)="startWebAuthn()">Use Passkeys</flat-button>
            }
            @if (error) {
              <form-error [error]="error"></form-error>
            }
            <br /><br />
            @if (!showChallenge) {
              <a routerLink="/forgotten-password" class="forgot-password-link">Forgot Password?</a>
            }
          </div>
        </card-content>
      </card-component>
    </div>
  </div>
</div>


